const React = require('react');
const ReactDOM = require('react-dom');

const ArtistBioItemContentContainer = require('./artist/ArtistContainer.jsx').ContentContainer;
const ArtistItemContentContainer = require('./artist/ItemContainer.jsx').ContentContainer;
const CertificateItemContentContainer = require('./certificate/ItemContainer.jsx').ContentContainer;
const ConsignmentLineItemCell = require('./consignment/LineItemCell.jsx');
const FontImports = require('./utility/FontImports.jsx');
const InvoiceLineItemCell = require('./invoice/LineItemCell.jsx');
const MosaicItemContentContainer = require('./mosaic/ItemContainer.jsx').ContentContainer;
const PageHeaderComponent = require('./common/PageHeader.jsx');
const PaymentCreditCell = require('./invoice/PaymentCreditCell.jsx');
const PricelistItemCell = require('./pricelist/ItemCell.jsx');
const PurchaseOrderLineItemCell = require('./purchaseOrder/LineItemCell.jsx');
const TearsheetItemContentContainer = require('./tearsheet/ItemContainer.jsx').ContentContainer;
const Templates = require('./utility/Templates.jsx');
const Types = require('./utility/Types.jsx');
const Utilities = require('./utility/Utilities.jsx');

const dropAreaId = 'dropArea';
function Body(props) {
    let Component = BodyContent;
    switch (props.configType) {
        case Types.Name.Config.PurchaseOrder:
        case Types.Name.Content.ArtistBioItem:
        case Types.Name.Content.ArtistInventoryItem:
        case Types.Name.Content.CertificateItem:
        case Types.Name.Content.ConsignmentLineItem:
        case Types.Name.Content.CreditLineItem:
        case Types.Name.Content.InvoiceLineItem:
        case Types.Name.Content.MosaicItem:
        case Types.Name.Content.PageHeader:
        case Types.Name.Content.PaymentLineItem:
        case Types.Name.Content.PricelistInventoryItem:
        case Types.Name.Content.PurchaseOrderLineItem:
        case Types.Name.Content.TearsheetItem:
            Component = BodyContentV2;
            break;
        case Types.Name.Config.ArtistBio:
        case Types.Name.Config.CertificateOfAuthenticity:
        case Types.Name.Config.Consignment:
        case Types.Name.Config.Invoice:
        case Types.Name.Config.Mosaic:
        case Types.Name.Config.Offer:
        case Types.Name.Config.Pricelist:
        case Types.Name.Config.Tearsheet:
            if ((props.config && props.config.Config) || (props.builder && props.contentConfig && props.contentConfig.Config)) {
                Component = BodyContentV2;
            }
            break;
    }
    return <Component {...props}>{props.children}</Component>
}

function _BodyContent(props) {
    if (props.builder) {
        switch (props.configType) {
            case Types.Name.Content.ArtistBioItem:
                return <ArtistBioItemContentContainer editor={true} id={dropAreaId} index={0} {...props} />
            case Types.Name.Content.ArtistInventoryItem:
                return <ArtistItemContentContainer editor={true} id={dropAreaId} index={0} {...props} />
            case Types.Name.Content.CertificateItem:
                return <CertificateItemContentContainer editor={true} id={dropAreaId} index={0} {...props} />
            case Types.Name.Content.ConsignmentLineItem:
                return <ConsignmentLineItemCell.Container.Component editor={true} id={dropAreaId} index={0} {...props} />
            case Types.Name.Content.CreditLineItem:
            case Types.Name.Content.PaymentLineItem:
                return <PaymentCreditCell.Container.Component editor={true} id={dropAreaId} index={0} {...props} />
            case Types.Name.Content.InvoiceLineItem:
                return <InvoiceLineItemCell.Container.Component editor={true} id={dropAreaId} index={0} {...props} />
            case Types.Name.Content.MosaicItem:
                return <MosaicItemContentContainer editor={true} id={dropAreaId} index={0} {...props} />
            case Types.Name.Content.PageHeader:
                return <PageHeaderComponent editor={true} id={dropAreaId} {...props} />
            case Types.Name.Content.PricelistInventoryItem:
                return <PricelistItemCell.Container.Component editor={true} id={dropAreaId} index={0} {...props} />
            case Types.Name.Content.PurchaseOrderLineItem:
                return <PurchaseOrderLineItemCell.Container.Component editor={true} id={dropAreaId} index={0} {...props} />
            case Types.Name.Content.TearsheetItem:
                return <TearsheetItemContentContainer editor={true} id={dropAreaId} index={0} {...props} />
        }
    }
    const data = props.data || {};
    const gallery = data.Gallery || {};
    const styleguide = data.Styleguide || {};
    let bodyFont;
    if (styleguide.BodyFont) {
        bodyFont = styleguide.BodyFont.FontFamily;
    }
    let width = "100%";
    let style = { fontWeight: 'normal', margin: 0, minWidth: width, width };
    if (props.collateralType == 0 || props.collateralType == 3) {
        // Email
        switch (props.configType) {
            case Types.Name.Config.Invoice:
            case Types.Name.Config.Offer:
            case Types.Name.Config.PurchaseOrder:
                width = '800';
                break;
            default:
                width = '600';
                break;
        }
        style.minWidth = `${width}px`;
        style.width = `${width}px`;
    }
    const hasPageHeader = Types.hasPageHeader(props.configType);
    let handleDrop = props.onDrop;
    if (props.onDocumentProps) {
        style = { ...style, ...props.onDocumentProps() };
    } else if (props.onPageProps) {
        if (!hasPageHeader || props.builder) {
            const pageProps = props.onPageProps();
            if (pageProps && pageProps.config && pageProps.config.Style) {
                style = { ...style, ...Utilities.Config.getStyleV2(pageProps.config.Style) };
            }
        }
    } else if (props.config.Document && props.config.Document.Config && props.config.Document.Config.Style) {
        style = { ...style, ...props.config.Document.Config.Style };
    } else if (props.config.Config && props.config.Config.document && props.config.Config.document.config && props.config.Config.document.config.Style) {
        handleDrop = undefined;
        if (!hasPageHeader || props.builder) {
            style = { ...style, ...Utilities.Config.getStyleV2(props.config.Config.document.config.Style) };
        }
    }
    if (props.builder && hasPageHeader && !props.v2) {
        style.paddingTop = 0;
    }
    return (
        <table
            border="0"
            cellPadding="0"
            cellSpacing="0"
            className={props.className}
            width="100%"
            onDragOver={props.onDragOver}
            onDrop={handleDrop}>
            <tbody>
                <tr>
                    <td align="center" valign="top">
                        <table border="0" cellPadding="0" cellSpacing="0" className="mobile-shell" width={width}>
                            <tbody>
                                <tr>
                                    <td className="td" style={style}>
                                        <table border="0" cellPadding="0" cellSpacing="0" width="100%">
                                            <tbody>
                                                {
                                                    !Utilities.isNullOrWhitespace(gallery.Message) &&
                                                    <tr>
                                                        <td className="main">
                                                            <div className="message-content" dangerouslySetInnerHTML={{ __html: gallery.Message }} style={{ color: '#000000', fontFamily: 'Arial, Helvetica, sans-serif', fontSize: '14px', lineHeight: 'normal' }} />
                                                        </td>
                                                    </tr>
                                                }
                                                {
                                                    props.collateralType == 0 &&
                                                    <tr>
                                                        <td className="main" style={{ padding: '20px 0px' }}>
                                                            <div dangerouslySetInnerHTML={{ __html: gallery.Signature }} style={{ color: styleguide.FontColor, fontFamily: bodyFont, fontSize: '16px' }} />
                                                        </td>
                                                    </tr>
                                                }
                                                <tr>
                                                    <td className="main">
                                                        {props.content}
                                                    </td>
                                                </tr>
                                                {
                                                    !Utilities.isNullOrWhitespace(data.Ad) &&
                                                    (props.collateralType == 0 || props.collateralType == 2 || props.collateralType == 3) &&
                                                    <tr>
                                                        <td className="main" style={{ paddingTop: '20px' }}>
                                                            <div dangerouslySetInnerHTML={{ __html: data.Ad }} style={{ color: styleguide.FontColor, fontFamily: bodyFont, fontSize: '16px' }} />
                                                        </td>
                                                    </tr>
                                                }
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
            </tbody>
        </table>
    );
}
const BodyContent = withConfigRendering(_BodyContent, ['Blocks']);
const BodyContentV2 = withConfigRendering(_BodyContent, ['Config', 'blocks'], true);

function Frame(props) {
    return (
        <FrameContainer head={<Head builder={props.builder} collateralType={props.collateralType} data={props.data} styles={props.styles} />} {...props}>
            <Body {...props} />
        </FrameContainer>
    );
}

class FrameContainer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};

        this._cancelRender = this._cancelRender.bind(this);
        this.renderFrameContent = this.renderFrameContent.bind(this);
    }

    componentDidMount() {
        this.renderFrameContent();
    }

    componentDidUpdate() {
        if (this.state.rendered) {
            return;
        }
        this.renderFrameContent();
    }

    componentWillUnmount() {
        this._cancelRender();
    }

    _cancelRender() {
        if (this.renderHandle) {
            clearTimeout(this.renderHandle);
            this.renderHandle = null;
        }
    }

    renderFrameContent() {
        if (this.updater && this.updater.isMounted && this.updater.isMounted(this)) {
            const temp = ReactDOM.findDOMNode(this);
            const doc = temp.contentDocument;
            if (doc && doc.readyState === 'complete' && doc.getElementById('frameContent') != null) {
                ReactDOM.render(this.props.head, doc.head);

                const contentContainer = doc.getElementById('frameContent');
                if (contentContainer && contentContainer.children && contentContainer.children.length == 0 && this.props.onLoad) {
                    const component = this;
                    setTimeout(function () {
                        component.props.onLoad({ currentTarget: temp });
                    }, 10);
                }
                ReactDOM.render(this.props.children, contentContainer);

                if (!this.props.builder && this.props.v2) {
                    this.setState({
                        rendered: true
                    });
                }
                return;
            }
        }
        // Wait for the iframe to be ready
        this._cancelRender();
        this.renderHandle = setTimeout(this.renderFrameContent, 0);
    }

    render() {
        return <iframe id={this.props.id} className={this.props.className} srcDoc="<div id='frameContent' />" style={this.props.style} />;
    }
}

function Head(props) {
    const data = props.data || {};
    const styleguide = data.Styleguide || {};
    let bodyFont;
    if (styleguide.BodyFont) {
        bodyFont = styleguide.BodyFont.FontFamily;
    }
    let pointerEvents = 'unset';
    if (!props.builder && props.collateralType != 0) {
        pointerEvents = 'none';
    }
    let html = `
        body {
            background: none;
            color: ${styleguide.FontColor};
            display: block !important;
            font-family: ${bodyFont};
            font-size: 12pt;
            margin: 0 !important;
            padding: 0 !important;
            pointer-events: ${pointerEvents};
            min-width: 100% !important;
            width: 100% !important;
        }
        p {
            margin: 0;
            padding: 0;
        }
        table {
            border-spacing: 0;
        }
        .pageBreakAfterAlways {
            page-break-after: always;
        }
        .pageBreakInsideAvoid {
            page-break-inside: avoid;
        }
    `;
    if (props.collateralType == 2 || props.collateralType == 3) {
        html += `.main td { font-size: 0; line-height: 1; } .main td > div, .main td > span { font-size: 16px; }`;
    }
    if (props.builder) {
        html += `.main td, #dropArea td { line-height: 1; }`;
    }
    if (props.styles) {
        html += props.styles;
    }
    const styles = <style dangerouslySetInnerHTML={{ __html: html }} />;
    return (
        <React.Fragment>
            {/* 
                    <!--[if gte mso 9]>
                    <xml>
                        <o:OfficeDocumentSettings>
                        <o:AllowPNG/>
                        <o:PixelsPerInch>96</o:PixelsPerInch>
                        </o:OfficeDocumentSettings>
                    </xml>
                    <![endif]--> 
                    */}
            <meta httpEquiv="Content-type" content="text/html; charset=utf-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
            <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
            <meta name="format-detection" content="date=no" />
            <meta name="format-detection" content="address=no" />
            <meta name="format-detection" content="telephone=no" />
            <FontImports.Legacy data={props.data} type={props.collateralType} />
            <FontImports.GoogleFontImport config={styleguide} />
            {styles}
        </React.Fragment>
    )
}

function _PageHeader(props) {
    let style = { fontWeight: 'normal', margin: 0 };
    if (props.onDocumentProps) {
        style = { ...style, ...props.onDocumentProps() };
    } else if (props.config.Document && props.config.Document.Config && props.config.Document.Config.Style) {
        style = { ...style, ...props.config.Document.Config.Style };
    }
    style.paddingBottom = 0;

    return (
        <FrameContainer head={<Head builder={props.builder} data={props.data} styles={props.styles} />} {...props}>
            <table border="0" cellPadding="0" cellSpacing="0" width="100%" onDragOver={props.onDragOver} onDrop={props.onDrop}>
                <tbody>
                    <tr>
                        <td className="main" style={style}>
                            {props.content}
                        </td>
                    </tr>
                </tbody>
            </table>
        </FrameContainer>
    );
}
const PageHeader = withConfigRendering(_PageHeader, ['PageHeaderBlocks']);

function withConfigRendering(WrappedComponent, configPath, v2) {
    return class extends React.Component {
        constructor(props) {
            super(props);

            let config = props.contentConfig || props.config;
            if (!config && !props.builder) {
                const templates = Templates[props.configType];
                if (templates && templates.length) {
                    config = templates[0];
                }
            }
            this.state = {
                config,
                hash: Utilities.Config.getVisibilityHash(config),
                kit: this._processKit(props)
            };

            this._processKit = this._processKit.bind(this);
            this.handleComponent = this.handleComponent.bind(this);
        }

        shouldComponentUpdate(nextProps, nextState) {
            if (nextProps.builder) {
                return true;
            }
            if (this.state.config && nextProps.config && this.state.config.id != nextProps.config.id) {
                return true;
            }
            const nextHash = Utilities.Config.getVisibilityHash(nextProps.config);
            if (nextHash != nextState.hash) {
                this.setState({
                    hash: nextHash
                });
                return true;
            }
            return false;
        }

        componentDidUpdate(prevProps) {
            const config = this.props.contentConfig || this.props.config;
            if (this.state.config && config && this.state.config.id != config.id) {
                this.setState({
                    config
                });
            }
            if (this.props.stylesheetId != prevProps.stylesheetId) {
                this.setState({
                    kit: this._processKit(this.props)
                });
            }
        }

        _processKit(props) {
            const kit = {};
            let kitContent = props.stylesheet;
            if (props.data && props.data.Styleguide) {
                kit.colors = {};
                if (props.data.Styleguide.FontColor) {
                    kit.colors.body = props.data.Styleguide.FontColor;
                }
                if (props.data.Styleguide.HeaderColor) {
                    kit.colors.header = props.data.Styleguide.HeaderColor;
                }
                if (!kitContent && props.data.Styleguide.Documents && props.data.Styleguide.Documents.Kit && props.data.Styleguide.Documents.Kit[Types.Kit.Type.Global]) {
                    kitContent = props.data.Styleguide.Documents.Kit[Types.Kit.Type.Global];
                }
            }
            if (!kitContent) {
                return kit;
            }
            for (let key in kitContent) {
                if (!kitContent[key]) {
                    continue;
                }
                const elementStyle = Utilities.extractStyle(kitContent[key].design, key);
                if (!elementStyle) {
                    continue;
                }
                kit[key] = elementStyle;
            }
            return kit;
        }

        handleComponent(d, contentBefore, contentAfter) {
            if (!this.state.config) {
                return null;
            }
            const block = Types.getBlock(Utilities.Config.getBlockType(d), this.state.config.Type, undefined, v2 != true);
            if (!block || !block.component) {
                return null;
            }
            const BlockComponent = block.component;
            let blockProps = {};
            if (this.props.onBlockProps) {
                blockProps = this.props.onBlockProps(d);
            }
            let className = blockProps.className;
            if (this.props.builder) {
                if (className) {
                    className += ' draggable';
                } else {
                    className = 'draggable';
                }
                if (blockProps.active) {
                    className += ' draggable-active';
                }
            }
            return (
                <BlockComponent
                    key={d.Id || d.id}
                    builder={this.props.builder}
                    className={className}
                    collateralConfig={this.state.config}
                    collateralType={this.props.collateralType}
                    config={blockProps.config || blockProps.block || d}
                    configType={this.props.configType}
                    contentAfter={contentAfter}
                    contentBefore={contentBefore}
                    data={this.props.data || {}}
                    dragging={this.props.dragging}
                    editor={this.props.editor}
                    forcePageHeader={this.props.forcePageHeader}
                    forceVisibility={this.props.forceVisibility}
                    kit={this.state.kit}
                    preview={this.props.preview}
                    serverSide={this.props.serverSide}
                    onBlockProps={this.props.onBlockProps}
                    onClick={this.props.onBlockClick}
                    onComponent={this.handleComponent}
                    onDragEnter={this.props.onDragEnter}
                    onDragStart={this.props.onBlockDragStart} />
            );
        }

        render() {
            let content;
            if (this.state.config && configPath) {
                let config = this.state.config;
                for (let i = 0; i < configPath.length; i++) {
                    config = config[configPath[i]];
                    if (!config) {
                        break;
                    }
                }
                if (config) {
                    content = []
                    if (!this.props.builder && configPath[configPath.length - 1] != 'PageHeaderBlocks' && Types.hasPageHeader(this.props.configType)) {
                        let contentAfter = [], contentBefore = [];
                        let itemConfig;
                        config.forEach((d) => {
                            if (d.Type == 'itemContainer' || (d.type && d.type.value == Types.Name.Block.Inventory.Container)) {
                                itemConfig = d;
                                return;
                            }
                            const BlockComponent = this.handleComponent(d);
                            if (!BlockComponent) {
                                return;
                            }
                            if (itemConfig) {
                                contentAfter.push(BlockComponent);
                            } else {
                                contentBefore.push(BlockComponent);
                            }
                        });
                        if (!itemConfig) {
                            content = contentBefore.concat(contentAfter);
                        } else {
                            const BlockComponent = this.handleComponent(itemConfig, contentBefore, contentAfter);
                            if (BlockComponent) {
                                content = [BlockComponent];
                            }
                        }
                    } else {
                        config.forEach((d) => {
                            const BlockComponent = this.handleComponent(d);
                            if (!BlockComponent) {
                                return;
                            }
                            content.push(BlockComponent);
                        });
                    }
                }
            }
            const extras = {};
            if (this.props.builder == true) {
                // Add a hidden element above the content so blocks can be dragged to the top (moving to first place)
                if (v2 == true) {
                    content = (
                        <>
                            {
                                Types.hasPageHeader(this.props.configType) &&
                                <PageHeaderComponent kit={this.state.kit} {...this.props} />
                            }
                            <div id={dropAreaId}
                                className={this.props.dragging ? 'dragging' : undefined}
                                onDragEnter={this.props.onDragEnter}
                                onDragOver={(e) => { if (e) { e.preventDefault() } }}
                                onDrop={this.props.onDrop}>
                                <div id="top-hidden-exit" className="hidden draggable" onDragEnter={this.props.onDragEnter} />
                                <div id="top-hidden-enter" className="hidden draggable" onDragEnter={this.props.onDragEnter} />
                                {content}
                                <div id="bottom-hidden-enter" className="bottom-hidden hidden draggable" onDragEnter={this.props.onDragEnter} />
                                <div id="bottom-hidden-exit" className="bottom-hidden hidden draggable" onDragEnter={this.props.onDragEnter} />
                            </div>
                        </>
                    )
                } else {
                    content = (
                        <div id="dropArea" className={extras.className}>
                            <div id="top-hidden" className="hidden draggable" />
                            {content}
                        </div>
                    );
                }
            }
            return (
                <WrappedComponent {...this.props} config={this.state.config || {}} content={content} kit={this.state.kit} v2={v2} {...extras}>
                    {this.props.children}
                </WrappedComponent>
            );
        }
    }
}

module.exports = {
    Body,
    Frame,
    Head,
    PageHeader,
    Types,
    Utilities
};